import Form from 'Components/Forms/FormGenerator';
import FormViewer from 'Components/FormViewer';
import { actions } from 'ducks/installationZones';
import React from 'react';
import { useSelector } from 'react-redux';
import { serializeForm } from 'utils/forms/utils';
import validators from 'utils/forms/validators';

const Component = props => {
    const { siteId, parentId } = props;
    const { onSave } = props;

    const submitting = useSelector(state => state.installationZones.submitting);

    const formSchema = [
        {
            label: 'Name\x2a',
            name: 'name',
            type: 'text',
            validate: [validators.required]
        },
        {
            type: 'textArea',
            label: 'Description',
            name: 'description',
            rows: 8
        }
    ];

    const create = actions.useCreate();

    const onSubmit = values => {
        const data = serializeForm(values, formSchema);
        if (parentId) {
            data.parent_id = parentId;
        } else {
            data.site_id = siteId;
        }

        create(data, onSave);
    };

    return (
        <FormViewer label="Add Installation Zone">
            <Form
                formSchema={formSchema}
                isSubmitting={submitting}
                onSubmit={onSubmit}
            />
        </FormViewer>
    );
};

export default Component;
